<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="partnerId"
            search-url="/partner/search?sortField=updatedAt&"
            create-url="/partner/save"
            delete-url="/partner/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <partner-create
            :propsItem="partner"
            :cDialog="visibleCreateDialog"
            :types="types"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import PartnerCreate from "./PartnerCreate.vue";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "partner",
    components: { PartnerCreate, CSearchForm },
    data: () => {
        return {
            formName: "Đối tượng",
            formCreateName: "Thêm mới đối tượng",
            partner: null,
            visibleCreateDialog: false,
            types: [],
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "partnerCode",
                    text: "Mã",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "typeId",
                    text: "Phân loại",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'typeId',
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "partnerName",
                    text: "Tên đối tượng",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "note",
                    text: "Ghi chú",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.materialStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "60px",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        axios
            .post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=PARTNER", {status: 1}
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.types = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "typeId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );
    },

    methods: {
        openCreateDialog: function (item = null) {
            this.partner = item;
            if (item == null) {
                this.formCreateName = 'Thêm mới đối tượng';
            } else {
                this.formCreateName = 'Cập nhật đối tượng';
            }
            this.visibleCreateDialog = true;
        },
        closeCreateDialog: function () {
            this.partner = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
